<script lang="ts">
  import { privacy } from "$lib/stores/privacy.svelte";
  import PinUnlockModal from "./PinUnlockModal.svelte";

  let { hasPin = false, compact = false } = $props<{ hasPin?: boolean; compact?: boolean }>();
  let pinOpen = $state(false);

  function onClick() {
    if (privacy.isPrivate) {
      privacy.lock();
      return;
    }
    if (!hasPin) {
      // sem PIN: redireciona pra settings via evento
      window.dispatchEvent(new CustomEvent("takite:privacy-need-pin"));
      return;
    }
    pinOpen = true;
  }

  // KaTeX-friendly note: pure cosmetic.
  const reduced = typeof window !== "undefined"
    && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
</script>

<button
  type="button"
  class="privacy-toggle"
  class:on={privacy.isPrivate}
  aria-pressed={privacy.isPrivate}
  aria-label={privacy.isPrivate ? "Bloquear camada privada" : "Desbloquear camada privada"}
  title={privacy.isPrivate ? "Camada privada ativa (clique para bloquear)" : "Desbloquear camada privada"}
  onclick={onClick}
>
  <span class="eye" aria-hidden="true">
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      {#if privacy.isPrivate}
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/>
        <circle cx="12" cy="12" r="3"/>
      {:else}
        <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-6.5 0-10-7-10-7a19.77 19.77 0 0 1 4.22-5.27"/>
        <path d="M9.88 4.24A10.94 10.94 0 0 1 12 4c6.5 0 10 7 10 7a19.77 19.77 0 0 1-2.16 3.19"/>
        <line x1="2" y1="2" x2="22" y2="22"/>
      {/if}
    </svg>
  </span>
  {#if !compact}
    <span class="label">{privacy.isPrivate ? "Privado" : "Padrão"}</span>
  {/if}
</button>

<PinUnlockModal bind:open={pinOpen} />

<style>
  .privacy-toggle {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.4rem 0.6rem;
    border-radius: 0.5rem;
    color: rgb(82 82 91);
    transition: background 200ms ease, color 200ms ease;
  }
  :global(.dark) .privacy-toggle { color: rgb(212 212 216); }
  .privacy-toggle:hover { background: rgb(244 244 245); }
  :global(.dark) .privacy-toggle:hover { background: rgb(39 39 42); }
  .privacy-toggle.on {
    color: rgb(220 38 38);
    background: rgb(254 226 226);
  }
  :global(.dark) .privacy-toggle.on {
    color: rgb(248 113 113);
    background: rgba(220, 38, 38, 0.15);
  }
  .eye :global(svg) {
    transition: transform 250ms cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  .privacy-toggle.on .eye :global(svg) { transform: scale(1.08); }
  .label { font-size: 0.78rem; font-weight: 500; }
  @media (prefers-reduced-motion: reduce) {
    .privacy-toggle, .eye :global(svg) { transition: none !important; }
  }
</style>
